export const WIDGET_MAX_HEIGHT = 700;
export const WIDGET_MIN_HEIGHT = 425;
export const COMPACT_TOKEN_SELECTOR_THRESHOLD = 640;
